<template>
  <div>
    <v-card color="back-to-students">
      <v-container v-if="!isStudent" class="pt-0 pb-0">
        <v-layout>
          <v-btn small flat class="back-btn" @click="goBack">
            <v-icon>arrow_back</v-icon>
            <span>{{backTitle}}</span>
          </v-btn>
        </v-layout>
      </v-container>
    </v-card>
    <v-card color="mt-0">
      <v-container class="pa-0">
        <v-layout row wrap>
          <v-flex xs12 sm6 class="prevent-overflow" style="overflow: hidden">
            <div class="display-1 pl-3 pr-3">{{student.firstName}} {{student.lastName}} ({{getDisplayId}})</div>
            <v-layout row>
              <v-flex class="prevent-overflow pr-2 ml-3" style="overflow: hidden;flex: 0 0 auto;">
                <img ref="studentPhoto" v-show="imageShow" v-bind:src="student.studentPhoto" v-on:load="imageLoaded" v-on:error="imageLoadError" class="img-size" />
                <v-icon v-show="!imageShow" style="font-size: 9em">person</v-icon>
              </v-flex>
              <div class="student-details">
                <div class="headline">
                  <div>{{courseDescription}}</div>
                  <span v-if="studentAge">{{$t('student_label_age')}} {{studentAge}} |</span>
                  {{$t('student_label_year')}}
                  {{student.courseYear}}
                </div>
              </div>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm6>
            <v-layout row wrap justify-space-around>

              <v-layout v-if="flagDisableAttendanceBubble" row justify-space-around>
                <v-tooltip lazy bottom>
                  <div class="engagement-column" slot="activator">
                    <div class="headline">{{$t('student_average_attendance')}}</div>
                    <div v-if="isStudent" class="engagement-circle engagement-title-percent-student">
                      <div class="blank-line">{{averageAttendance | percent}}</div>
                    </div>
                    <div v-else-if="averageAttendance >= 0"  class="engagement-circle engagement-title-percent">
                      <div class="blank-line">{{averageAttendance | percent}}</div>
                      <div v-if="courseAverageAttendance >= 0" class="engagement-title-percent-course">
                        {{$t('student_course_average_attendance')}} {{courseAverageAttendance | percent}}
                      </div>
                    </div>
                    <div v-else class="engagement-circle engagement-title-percent-student">
                      {{$t('not_applicable')}}
                    </div>
                  </div>
                  <span v-html="$t('student_attendance_tooltip_html', {daysForStudentAttendance})"></span>
                </v-tooltip>
              </v-layout>

              <v-layout v-if="flagDisplayGrade" row justify-space-around>
                <v-tooltip lazy bottom :allow-overflow="true" max-width="300">
                  <div class="engagement-column" slot="activator">
                    <div class="headline">{{$t('student_engagement_grade')}}</div>
                    <div class="engagement-circle engagement-title-percent-student">
                      <div v-if="student.averageGrade">
                      	{{student.averageGrade}}
                      </div>
                      <div v-else>{{$t('not_applicable')}}</div>
                    </div>
                  </div>
                  <span v-html="$t('student_grade_tooltip_html')"></span>
                </v-tooltip>
              </v-layout>

              <v-layout v-if="flagDisplayEngagement" row justify-space-around>
                <v-tooltip lazy bottom :allow-overflow="true" max-width="300">
                  <div class="engagement-column" slot="activator">
                    <v-layout column align-center>
                      <div class="headline">{{$t('student_current')}}</div>
                      <div class="engagement-circle engagement-title" v-bind:class="[studentRatingClasses]">
                        <div v-if="student.latestEngagementRating">
                        {{studentRating}}
                        </div>
                        <div v-else class="engagement-title-percent-student">
                          {{$t('not_applicable')}}
                        </div>
                      </div>
                    </v-layout>
                  </div>
                  <span v-html="$t('student_engagement_how_calculated_tooltip_html')"></span>
                </v-tooltip>
              </v-layout>

              <v-layout v-if="flagDisplayAverageEngagement" row justify-space-around>
                <v-tooltip lazy bottom :allow-overflow="true" max-width="300">
                  <div class="engagement-column" slot="activator">
                    <v-layout column align-center>
                      <div class="headline">{{$t('student_average_engagement')}}</div>
                      <div class="engagement-circle engagement-title" v-bind:class="[studentAverageRatingClasses]">
                        <div v-if="student.latestAverageEngagementRating">
                          {{studentAverageRating}}
                        </div>
                        <div v-else class="engagement-title-percent-student">
                          {{$t('not_applicable')}}
                        </div>
                      </div>
                    </v-layout>
                  </div>
                  <span v-html="$t('student_average_engagement_calculated_tooltip.html')"></span>
                </v-tooltip>
              </v-layout>

              <v-layout v-if="flagDisplayTrend" row justify-space-around>
                <v-tooltip lazy bottom :allow-overflow="true" max-width="300">
                  <div class="engagement-column" slot="activator">
                    <div class="headline">{{$t('student_trend')}}</div>
                    <div class="engagement-circle white-circle">
                      <div class="trend">
                        <v-icon x-large v-bind:style="trendAngleStyle">mdi-arrow-right</v-icon>
                      </div>
                    </div>
                  </div>
                  <span v-html="$t('student_trend_tooltip_html')"></span>
                </v-tooltip>
              </v-layout>

            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

      <custom-text :msg="customText" :customValue="studentData" class="mt-2 mb-1"></custom-text>
      <v-tabs grow show-arrows v-model="activeTab" slider-color="secondary">
        <v-tab key=0 id="tab_engagement">{{$t('student_engagement')}}</v-tab>
        <v-tab key=1 id="tab_profile">{{$t('student_profile')}}</v-tab>
        <v-tab key=2 id="tab_intervention" v-if="flagEnableInteractionsTab">
          {{$t('student_interaction')}}
        </v-tab>
        <v-tab key=3 id="tab_attendance">{{$t('student_attendance')}}</v-tab>
        <v-tab key=4 id="tab_resources">{{$t('student_resources')}}</v-tab>
        <v-tab key=5 id="tab_assessments">{{$t('student_assessments')}}</v-tab>


          <v-tab-item key=0>
            <v-container>
              <StudentEngagement :studentId="studentId" :active="onEngagementTab"></StudentEngagement>
            </v-container>
          </v-tab-item>
          <v-tab-item key=1>
            <v-container>
              <StudentProfile :studentProfile="studentProfile" :studentId="studentId" :active="onProfileTab"></StudentProfile>
            </v-container>
          </v-tab-item>
          <v-tab-item key=2 v-if="flagEnableInteractionsTab">
            <v-container>
              <student-interaction-page :studentId="studentId" :interactions="filteredInteractionsList" :interventionsLoading="interventionsLoading"
                                       :student="student" :active="onInteractionsTab"/>
            </v-container>
          </v-tab-item>
          <v-tab-item key=3>
            <v-container>
              <student-attendance :studentId="studentId" :active="onAttendanceTab"></student-attendance>
            </v-container>
          </v-tab-item>
          <v-tab-item key=4>
            <v-container>
              <resources-grid :active="onResourcesTab" :studentId="studentId"/>
            </v-container>
          </v-tab-item>
          <v-tab-item key=5>
            <v-container>
              <student-assessments :active="onAssessmentsTab" :studentId="studentId"/>
            </v-container>
          </v-tab-item>
      </v-tabs>

  </div>
</template>

<script>
  import {
    GET_STUDENT,
    GET_STUDENT_AVERAGE_ATTENDANCE,
    GET_STUDENT_CALENDAR_INFORMATION,
    GET_STUDENT_COURSE_AVERAGE_ATTENDANCE
  } from '../../store/action-types'
  import { RESET_STUDENT } from '../../store/mutation-types'
  import { mapGetters, mapState } from 'vuex'
  import StudentEngagement from './engagement/StudentEngagement'
  import StudentProfile from './profile/StudentProfile'
  import StudentAttendance from './StudentAttendance'
  import StudentProfileInterventionHeader from '../intervention/studentProfileIntervention/StudentProfileInterventionHeader'
  import StudentProfileInterventionBody from '../intervention/studentProfileIntervention/StudentProfileInterventionBody'
  import {
    FROM_INTERACTIONS_LIST,
    GET_STUDENT_AGE,
    GET_STUDENT_COURSE_DESCRIPTION,
    GET_STUDENT_VISIBLE_INTERACTIONS,
    IS_STUDENT,
    HAS_FEATURE_FLAG
  } from '../../store/getter-types'
  import StudentProfileInteraction from '../intervention/studentProfileIntervention/StudentProfileInteraction'
  import ResourcesGrid from '../resources/ResourcesGrid'
  import FabDial from '../misc/fab/FabDial'
  import StudentInteractionPage from './interaction/StudentInteractionPage'
  import Colors from '../../mixins/Colors'
  import StudentAssessments from './StudentAssessments'
  import CustomText from '../help/CustomText'
  import Roles from '../../mixins/Roles'

  let ratingMapping = {
    'NONE': {letter: 'N', color: 'grey'},
    'VERY_LOW': {letter: 'V', color: 'red'},
    'LOW': {letter: 'L', color: 'orange'},
    'PARTIAL': {letter: 'P', color: 'purple lighten-2'},
    'GOOD': {letter: 'G', color: 'light-blue'},
    'HIGH': {letter: 'H', color: 'green'}
  }

  function getRating (rating, field, defaultValue) {
    if (ratingMapping[rating]) {
      return ratingMapping[rating][field]
    }
    return defaultValue
  }

  export default {
    name: 'StudentPage',
    mixins: [Colors, Roles],
    data () {
      return {
        showTooltip: false,
        activeTab: (this.isInteraction()) ? '2' : (this.isAttendance()) ? '3' : '0',
        open: true,
        imageShow: true
      }
    },
    methods: {
      imageLoadError () {
        this.imageShow = false
      },
      imageLoaded () {
        this.imageShow = true
      },
      isInterventions () {
        return (this.$route.name === 'TutorIntervention')
      },
      isAlerts () {
        return (this.$route.name === 'TutorAlert')
      },
      isExemption () {
        return (this.$route.name === 'TutorExemption')
      },
      isInteraction () {
        return (this.$route.name === 'TutorInteractions') || this.isExemption() || this.isAlerts() || this.isInterventions()
      },
      isAttendance () {
        return (this.$route.name === 'TutorAttendance')
      },
      goBack () {
        let backLinkName = this.fromInteractionsList ? 'Interactions' : 'Students'
        this.$router.push({name: backLinkName})
      },
      checkKey (key) {
        let newKey = key === 2 ? -1
          : key === 3 ? 2
            : key === 4 ? 3
              : key === 5 ? 4
                : -1
        return this.flagEnableInteractionsTab ? key : newKey
      }
    },
    computed: {
      ...mapState({
        student: state => state.student.student,
        studentProfile: state => state.student.studentProfile,
        loginStudentId: state => state.profile.studentId,
        interventionsLoading: state => state.student.interventionsLoading,
        averageAttendance: state => state.student.averageAttendance,
        courseAverageAttendance: state => state.student.averageCourseAttendance,
        daysForStudentAttendance: state => state.config.daysForStudentAttendance,
        studentData: state => state.student,
        moduleAttendance: state => state.profile.module.attendance,
        moduleStudent: state => state.profile.module.student,
        moduleInterExem: state => state.profile.module.interexem,
        moduleEngagement: state => state.profile.module.engagement,
        moduleAlert: state => state.profile.module.alert,
        functionStudent: state => state.student.functions.student,
        functionMyStudent: state => state.students.functions.myStudents,
        functionGrade: state => state.student.functions.grade,
        functionTrend: state => state.student.functions.trend,
        functionStudentInteractions: state => state.student.functions.studentInteractions,
        functionInteractions: state => state.interactions.functions.interactions,
        optionDisableAttendanceBubble: state => state.student.options.disable.attendanceBubble,
        optionEnableAverageEngagement: state => state.students.options.enable.averageEngagement,
        optionDisableGradeBubble: state => state.student.options.disable.gradeBubble,
        optionDisableTrendBubble: state => state.student.options.disable.trendBubble,
        optionEnableInteractionsTab: state => state.student.options.enable.interactionsTab,
        optionDisableEngagementBubble: state => state.student.options.disable.engagementBubble,
        optionEnableAlertFilter: state => state.interactions.options.enable.alertFilter
      }),
      ...mapGetters({
        interactions: GET_STUDENT_VISIBLE_INTERACTIONS,
        courseDescription: GET_STUDENT_COURSE_DESCRIPTION,
        studentAge: GET_STUDENT_AGE,
        isStudent: IS_STUDENT,
        fromInteractionsList: FROM_INTERACTIONS_LIST,
        hasFeatureFlag: HAS_FEATURE_FLAG
      }),
      interventionsState: {
        get () {
          return this.$store.state.student.interventionsState
        },
        set (value, x) {}
      },
      onEngagementTab () {
        return this.activeTab === '0'
      },
      onProfileTab () {
        return this.activeTab === '1'
      },
      onInteractionsTab () {
        return this.activeTab === this.checkKey(2).toString()
      },
      onAssessmentsTab () {
        return this.activeTab === this.checkKey(5).toString()
      },
      onResourcesTab () {
        return this.activeTab === this.checkKey(4).toString()
      },
      onAttendanceTab () {
        return this.activeTab === this.checkKey(3).toString()
      },
      backTitle () {
        let key = this.fromInteractionsList
          ? 'student_back_to_interventions' : 'student_back_to_students'
        return this.$t(key)
      },
      studentRating (state) {
        let ratingLetter = ''
        if (this.student.latestEngagementRating) {
          ratingLetter = getRating(this.student.latestEngagementRating, 'letter', '')
        }
        return ratingLetter
      },
      studentAverageRating (state) {
        let averageRatingLetter = ''
        if (this.student.latestAverageEngagementRating) {
          averageRatingLetter = getRating(this.student.latestAverageEngagementRating, 'letter', '')
        }
        return averageRatingLetter
      },
      studentRatingClasses (state) {
        return getRating(this.student.latestEngagementRating, 'color', 'gray')
      },
      studentAverageRatingClasses (state) {
        return getRating(this.student.latestAverageEngagementRating, 'color', 'gray')
      },
      trendAngleStyle () {
        return {
          transform: 'rotate(' + (this.student.trend * -22.5) + 'deg)'
        }
      },
      studentId () {
        let paramId = this.$route.params.id
        let loginStudentId = this.loginStudentId
        if (this.isStudent) {
          return loginStudentId
        } else {
          return paramId
        }
      },
      filteredInteractionsList () {
        if (!this.flagEnableAlertFilter) {
          return this.interactions.filter(el => el.interactionType !== 'ALERT')
        }
        return this.interactions
      },
      flagDisableAttendanceBubble () {
        return !this.hasFeatureFlag(this.moduleAttendance + '.' + this.functionStudent + '.' + this.optionDisableAttendanceBubble)
      },
      flagDisplayGrade () {
        return !this.hasFeatureFlag(this.moduleStudent + '.' + this.functionGrade + '.' + this.optionDisableGradeBubble)
      },
      flagDisplayEngagement () {
        return !this.hasFeatureFlag(this.moduleEngagement + '.' + this.functionStudent + '.' + this.optionDisableEngagementBubble)
      },
      flagDisplayTrend () {
        return !this.hasFeatureFlag(this.moduleEngagement + '.' + this.functionTrend + '.' + this.optionDisableTrendBubble)
      },
      flagDisplayAverageEngagement () {
        return this.hasFeatureFlag(this.moduleStudent + '.' + this.functionMyStudent + '.' + this.optionEnableAverageEngagement)
      },
      customText () {
        let role = this.isAdmin ? 'admin' : (this.isStaff ? 'staff' : 'student')
        return 'custom-text.' + role + '.page'
      },
      flagEnableInteractionsTab () {
        return this.hasFeatureFlag(this.moduleInterExem + '.' + this.functionStudentInteractions + '.' + this.optionEnableInteractionsTab)
      },
      flagEnableAlertFilter () {
        return this.hasFeatureFlag(this.moduleAlert + '.' + this.functionInteractions + '.' + this.optionEnableAlertFilter)
      },
      getDisplayId () {
        return this.student.displayId ? this.student.displayId : this.student.studentIdentifier
      }
    },
    watch: {
      student (student) {
        if (student.studentPhoto) {
          this.$refs.studentPhoto.src = student.studentPhoto
          this.imageShow = true
        } else {
          this.imageShow = false
        }
        if (student.course) {
          if (!this.isStudent) {
            this.$store.dispatch(GET_STUDENT_COURSE_AVERAGE_ATTENDANCE, student.cohortId)
          }
        }
      }
    },
    filters: {
      percent (value) {
        return ((value === undefined) || (value < 0)) ? '' : value + '%'
      }
    },
    components: {
      StudentAssessments,
      StudentInteractionPage,
      FabDial,
      ResourcesGrid,
      StudentProfileInteraction,
      StudentEngagement,
      StudentProfile,
      StudentAttendance,
      StudentProfileInterventionBody,
      StudentProfileInterventionHeader,
      CustomText
    },
    mounted () {
      window.scrollTo(0, 0)
    },
    created () {
      this.$store.commit(RESET_STUDENT)
      this.$store.dispatch(GET_STUDENT, this.studentId)
      this.$store.dispatch(GET_STUDENT_CALENDAR_INFORMATION, this.studentId)
      this.$store.dispatch(GET_STUDENT_AVERAGE_ATTENDANCE, this.studentId)
    }
  }
</script>

<style scoped>
  .student-details {
    padding-right: 4px;
    vertical-align: middle;
    overflow: hidden;
  }

  .back-btn {
    text-transform: none;
    margin-left: 0px;
    font-size: 14px;
  }

  .btn.back-btn > > > .btn__content {
    padding-left: 0px;
  }

  .back-to-students {
    margin-bottom: 2px;
  }

  .expansion-panel-custom {
    border-bottom: 1px solid #ededed;
  }

  .tabs__li:hover {
    background: #E1E1E1;
  }

  #tab-engagement {
    min-height: 50vh;
  }

  .engagement-column {
    display: inline-block;
    width: 120px;
    text-align: center;
    margin-left: 4px;
    margin-right: 4px;
    vertical-align: top;
    padding-bottom: 16px;
  }

  .engagement-column:first-child {
    margin-left: 0px;
  }

  .engagement-column:last-child {
    margin-right: 0px;
  }

  .engagement-circle {
    display: inline-block;
    color: white;
    text-align: center;
    border-radius: 40px;
    border: 2px solid gray;
    background-color: gray;
    padding: 0px;
    width: 80px;
    height: 80px;
  }

  .engagement-circle.white-circle {
    background-color: white;
  }

  .engagement-title {
    padding-top: 0px;
    font-size: 50px;
  }

  .engagement-title-percent-student {
    padding-top: 13px;
    font-size: 28px;
  }

  .engagement-title-percent {
    padding-top: 3px;
    font-size: 28px;
  }

  .engagement-title-percent-course {
    margin-top: -7px;
    font-size: 12px;
  }

  .trend {
    margin-top: 18px;
  }

  button.link.btn {
    text-decoration: underline;
    text-transform: none;
  }

  .blank-line {
    min-height: 1.5em;
  }

  .icon {
    color: rgba(0,0,0,.54);
  }

  .headline {
    font-weight: 300;
  }
  .tabs__div:hover{
    background: lightgray;
  }

  .img-size {
    max-width: 120px;
    max-height: 120px;
  }

</style>

<style>
  @media only screen and (min-width: 1904px){
    .tabs__container {
      max-width: 1785px;
      margin:0 auto;
    }
  }

  @media only screen and (min-width: 1264px) and (max-width: 1903px){
    .tabs__container {
      max-width: 1185px;
      margin:0 auto;
    }
  }

  @media only screen and (max-width: 1263px){
    .tabs__container {
      max-width: 900px;
      margin:0 auto;
    }
  }

  @media only screen and (max-width: 375px){
    .headline {
      font-size: 20px!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/student/StudentPage.vue